{
  "AGENT_BOTS": {
    "HEADER": "Bot",
    "LOADING_EDITOR": "Memuat editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try. You can manage your bots from this page or create new ones using the 'Add Bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "COUNT": "{n} bot | {n} bots",
    "SEARCH_PLACEHOLDER": "Search bots...",
    "NO_RESULTS": "No bots found matching your search",
    "GLOBAL_BOT": "System bot",
    "GLOBAL_BOT_BADGE": "Sistem",
    "AVATAR": {
      "SUCCESS_DELETE": "Bot avatar deleted successfully",
      "ERROR_DELETE": "Error deleting bot avatar, please try again"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Pilih bot agen",
      "DESC": "Tetapkan Bot Agen ke kotak masuk Anda. Mereka dapat menangani percakapan awal dan meneruskannya ke agen manusia jika diperlukan.",
      "SUBMIT": "Perbarui",
      "DISCONNECT": "Putuskan koneksi",
      "SUCCESS_MESSAGE": "Berhasil memperbarui bot agen.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Berhasil memutuskan hubungan bot agen.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot"
    },
    "ADD": {
      "TITLE": "Add Bot",
      "CANCEL_BUTTON_TEXT": "Batalkan",
      "API": {
        "SUCCESS_MESSAGE": "Bot berhasil ditambahkan.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Add Bot' button.",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Bot Details",
        "URL": "URL Webhook",
        "ACTIONS": "Aksi"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Hapus",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "Konfirmasi Penghapusan",
        "MESSAGE": "Are you sure you want to delete {name}?",
        "YES": "Ya, Hapus",
        "NO": "Tidak, Simpan"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot berhasil dihapus.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Edit",
      "TITLE": "Edit bot",
      "API": {
        "SUCCESS_MESSAGE": "Bot berhasil diperbarui.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      }
    },
    "SECRET": {
      "LABEL": "Webhook Secret",
      "COPY": "Copy secret to clipboard",
      "COPY_SUCCESS": "Secret copied to clipboard",
      "TOGGLE": "Toggle secret visibility",
      "CREATED_DESC": "Use the secret below to verify webhook signatures. Please copy it now, you can also find it later in the bot settings.",
      "DONE": "Done",
      "RESET_SUCCESS": "Webhook secret regenerated successfully",
      "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
    },
    "ACCESS_TOKEN": {
      "TITLE": "Token Akses",
      "DESCRIPTION": "Copy the access token and save it securely",
      "COPY_SUCCESSFUL": "Access token copied to clipboard",
      "RESET_SUCCESS": "Access token regenerated successfully",
      "RESET_ERROR": "Unable to regenerate access token. Please try again"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Bot avatar"
      },
      "NAME": {
        "LABEL": "Bot name",
        "PLACEHOLDER": "Enter bot name",
        "REQUIRED": "Nama bot wajib diisi"
      },
      "DESCRIPTION": {
        "LABEL": "Deskripsi",
        "PLACEHOLDER": "Apa yang dilakukan bot ini?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL Webhook",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "Webhook URL is required"
      },
      "ERRORS": {
        "NAME": "Nama bot wajib diisi",
        "URL": "Webhook URL is required",
        "VALID_URL": "Please enter a valid URL starting with http:// or https://"
      },
      "CANCEL": "Batalkan",
      "CREATE": "Create Bot",
      "UPDATE": "Update Bot"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Configure a webhook bot to integrate with your custom services. The bot will receive and process events from conversations and can respond to them."
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot"
    }
  }
}
